<template>
  <div>
    <p class="text-muted m-none">{{ completedStatus }}</p>
    <el-steps :active="activeStep" class="mt-1 onboarding-progress-bar">
      <el-step v-for="step in steps" :key="step.title"></el-step>
    </el-steps>

    <el-steps
      direction="vertical"
      :active="activeStep"
      class="onboarding-steps"
    >
      <el-step v-for="(step, i) in steps" :key="i">
        <template #title>
          <router-link
            v-if="i === activeStep"
            v-slot="{ href, navigate }"
            :to="step.href"
            custom
          >
            <el-card
              :href="href"
              shadow="never"
              class="step-card is-process"
              @click="initiateOnboarding(navigate)"
            >
              <StepContent :step="step" :num="i" />
            </el-card>
          </router-link>
          <el-card
            v-else
            shadow="never"
            :class="['step-card', { 'is-success': i < activeStep }]"
          >
            <StepContent
              :step="step"
              :num="i"
              :tag="i < activeStep ? 'Done' : 'Up next'"
            />
          </el-card>
        </template>
      </el-step>
    </el-steps>
  </div>
</template>
<script lang="ts">
import { defineComponent, computed } from 'vue'
import StepContent from './StepContent.vue'
import { ONBOARDING_STEPS } from '@/apps/traforama/constants'
import { useUserStore } from '@/store/modules/user'

export default defineComponent({
  name: 'OnboardingStep',
  components: { StepContent },
  props: {
    activeStep: {
      type: Number,
      default: 0
    }
  },
  setup(props) {
    const steps: any[] = ONBOARDING_STEPS
    const userStore = useUserStore()

    const completedStatus = computed(() => {
      return `${props.activeStep}/${steps.length} completed`
    })

    const initiateOnboarding = (navigate: () => void) => {
      userStore.isProcessingOnboarding = true
      navigate()
    }

    return { steps, completedStatus, initiateOnboarding }
  }
})
</script>

<style lang="scss" scoped></style>
